import React from "react";
import { DescriptionLoaderTemplate } from "themes/common/components";

function DescriptionLoader(props) {
    return <DescriptionLoaderTemplate {...props} />;
}

export default DescriptionLoader;
